<template>
  <el-dropdown trigger="click"
               @command="changeValues"
               ref="dropdown"
               :hide-on-click="!multiple"
               @visible-change="changeShow"
               placement="bottom">
    <span class="el-dropdown-link"
          :class="border && 'border'">
      {{ getTitle }}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown"
                      class="dropdown"
                      :class="border && 'bordered'"
                      :disabled="true">
      
      <el-input v-if="showSearch"
                v-model.trim="kw"
                style="width: 150px; margin: 0 10px;"
                :placeholder="placeholder"
                suffixIcon="el-icon-search"
                size="small"
                clearable></el-input>
      <div class="line"
           v-if="showSearch"></div>
      <el-scrollbar ref="selectScrollBar">
        <div class="dropHeight" :style="dropStyle">
          <el-dropdown-item v-for="(item, index) in option"
                            :class="item.select && 'actives'"
                            :disabled="item.disabled"
                            :command="item"
                            :key="index">
            <div class="flex" :style="item.style">
              <i class="icon iconfont icon-xuanzhong"
                 v-if="multiple && item.select"></i>
              <i class="unselected"
                 v-if="multiple && !item.select"></i>
              <symbolIcon v-if="item.icon" :name="item.icon" style="margin-right: 5px;font-size: 16px;"></symbolIcon>
              {{ item[props.label] }}
              
            </div>
          </el-dropdown-item>
        </div>
      </el-scrollbar>
      <div class="line"
           v-if="multiple"></div>
      <div class="searchBtns"
           v-if="multiple">
        <el-button type="primary"
                   size="mini"
                   @click="confirm(1)">确定</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="confirm(0)">取消</el-button>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
import _ from 'lodash'
import formStore from '@/mixins/formStore.js'
import symbolIcon from '@/components/iglobalwin/ig-icon/symbolIcon.vue';

export default {
  props: {
    value: null,
    options: {
      default: () => [],
    },
    border: Boolean,
    multiple: Boolean,
    defaultText: {
      default: '请选择',
    },
    placeholder: {
      default: '请输入关键字',
      type: String,
    },
    trigger: {
      default: 'click',
      type: String,
    },
    showSearch: {
      default: false,
      type: Boolean,
    },
    props: {
      default () {
        return {
          label: 'label',
          value: 'value',
        }
      },
    },
    dropStyle: {
      default() {
        return {}
      }
    },
    data: {
      default: () => { },
      type: Object,
    },
    filterMethod: Function,
  },
  mixins: [formStore],
  components: {
    symbolIcon
  },
  data () {
    return {
      originOption: _.cloneDeep(this.options),
      originData: this.value,
      // option: this.options || [],
      result: this.multiple ? _.cloneDeep(this.value) : this.value,
      labels: this.multiple ? [] : '',
      kw: '',
    }
  },
  computed: {
    getTitle () {
      if (this.multiple && this.labels.length !== 0) {
        return this.labels.join(',')
      } else if (!this.multiple && this.labels && this.labels !== '') {
        return this.labels
      }
      return this.defaultText
    },
    getOption () {
      return this.option
    },
    option: {
      get () {
        return (
          this.options.filter((item) => {
            return !item.hide
          }) || []
        )
      },
      set (newVal) {
        return (
          newVal.filter((item) => {
            return !item.hide
          }) || []
        )
      },
    },
  },
  mounted () {
    this.option = this.options
    if (!this.multiple) {
      this.result = this.value
    } else {
      this.result = _.cloneDeep(this.value)
    }
  },
  watch: {
    options: function (val) {
      if (!this.remoteMethod) {
        this.option = val
        this.originOption = val
      }
    },
    value: {
      handler (val) {
        if (!this.multiple) {
          this.result = val
        } else {
          this.result = _.cloneDeep(val)
          this.originData = _.cloneDeep(val)
        }
      },
      deep: true,
    },
    result: {
      handler (val) {
        this.changeStatus()
        this.getViews()
      },
      immediate: true,
    },
    kw (val, oldVal) {
      const options = _.cloneDeep(this.originOption)
      if (typeof this.filterMethod !== 'undefined') {
        this.filterMethod(val, this.option, options)
        return
      }
      if (val !== '') {
        this.option = _.map(this.option, (item) => {
          if (item.options) {
            item.options = _.filter(item.options, (value) => {
              return value[this.props.label].indexOf(val) !== -1
            })
          }
          return item[this.props.label].indexOf(val) !== -1 ||
            (item.options && item.options.length > 0)
            ? _.assign(item, { hide: false })
            : _.assign(item, { hide: true })
        })
      } else {
        if (val !== oldVal && val === '') {
          this.option = _.map(this.option, (item) =>
            _.assign(item, { hide: false })
          )
        }
      }
    },
  },
  methods: {
    changeValues (item) {
      this.getValues(item)
      this.changeStatus(item)
      !this.delay && !this.multiple && this.setVal('input', this.result)
    },
    setVal () {
      this.$emit('input', this.result)
      this.$emit('change', this.result)
    },
    getVal () {
      this.result = _.clone(this.value)
    },
    confirm (type) {
      if (type === 1) {
        this.setValues()
      } else {
        this.setOrigin()
      }
      !this.delay && this.setVal()
      //      this.$emit("input", _.cloneDeep(this.result));
      this.$refs.dropdown.hide()
    },
    setValues () {
      this.originOption = _.cloneDeep(this.option)
      this.originData = _.cloneDeep(this.result)
    },
    setOrigin () {
      this.option = _.cloneDeep(this.originOption)
      this.result = _.cloneDeep(this.originData)
      this.changeStatus()
    },
    changeShow (type) {
      !type &&
        this.$refs.selectScrollBar &&
        (this.$refs.selectScrollBar.moveY = 0)
      if (!type && this.multiple) {
        this.confirm(0)
      }
    },
    getValues (item) {
      let val = _.cloneDeep(item[this.props.value])
      if (!this.multiple) {
        this.result = val
      } else {
        let index = _.findIndex(this.result, (item) => item === val)
        if (index === -1) {
          this.result.push(val)
        } else {
          this.result.splice(index, 1)
        }
      }
    },
    getViews () {
      let labels = _.chain(this.option)
        .filter((item) => item.select)
        .map((val) => val[this.props.label])
        .value()
      this.labels = this.multiple ? labels : labels[0]
    },
    changeStatus () {
      if (!this.multiple) {
        this.option = _.map(this.option, (item) => {
          return item[this.props.value] === this.result
            ? _.assign(item, { select: true })
            : _.assign(item, { select: false })
        })
      } else {
        this.option = _.map(this.option, (item) => {
          let index = _.findIndex(
            this.result,
            (val) => item[this.props.value] === val
          )
          return index !== -1
            ? _.assign(item, { select: true })
            : _.assign(item, { select: false })
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
  &:hover .unselected {
    border-color: #66b1ff;
  }
}

.unselected {
  width: 14px;
  height: 14px;
  margin-right: 10px;
  border: 1px solid #d5d8de;
  border-radius: 2px;
  display: inline-block;
}

.line {
  height: 1px;
  margin: 10px auto;
  background-color: #d8d8d8;
}

.el-dropdown-link {
  cursor: pointer;
}

.el-dropdown-link:not([class*="border"]) {
  font-weight: 600;
  .el-icon-arrow-down {
    font-weight: 600;
  }
}

.dropdown {
  min-width: 140px;
  .dropHeight {
    max-height: 180px;
  }
  .icon-xuanzhong {
    font-size: 14px;
    color: #1989fa;
    margin-right: 10px;
  }
}

.dropdown li.el-dropdown-menu__item.actives {
  background-color: #ecf5ff;
  color: #66b1ff;
}

.searchBtns {
  display: flex;
  justify-content: center;
}

.dropdown ::v-deep .el-dropdown-menu__item:focus:not(.actives) {
  background: #fff;
  color: #606266;
}

.border {
  border: 1px solid #dcdfe6;
  background: #fff;
  border-radius: 4px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  line-height: 36px;
  width: 100%;
  justify-content: space-between;
}

.bordered.dropdown {
  width: 500px;
}
</style>
